import React, { useState, useEffect } from "react";
import { useObjectStore } from "../zustand/objects";
import { Switch, ActionIcon, Menu, Text } from '@mantine/core';
import { editorModalBorder, leftNavMenuProps } from "../styleFile";
import { IconHandMove, IconMessageCircle } from '@tabler/icons-react';

const CommentCursor = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        
        const updateMousePosition = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        window.addEventListener("mousemove", updateMousePosition);

        return () => {
            window.removeEventListener("mousemove", updateMousePosition);
        };
    }, []);

   
    return (
        <div style={{ cursor: "none" }}> {/* Hides the default cursor */}
            <div
                style={{
                    position: "fixed",
                    top: position.y,
                    left: position.x,
                    pointerEvents: "none", // Ensures it doesn't interfere with clicks
                    transform: "translate(-50%, -50%)",
                    fontSize: "24px"
                }}>💬
                {/* <CommentOutlinedIcon style={{ fontSize: "24px", color: "black" }} /> */}

            </div>
        </div>
    );
}


export const AddCommentButton = ({ leftNav = false, iconColour = { normal: "#606060ff", hover: "#868e96" } }) => {
    const {
        commentClickStatus,
        handleCommentButtonClick,
        setShowingComments,
        showingComments
    } = useObjectStore();

    const [hover1, setHover1] = useState(false)
    const handleClick = () => {
        handleCommentButtonClick('add')
        // handleCommentButtonClick(!commentClickStatus.clicking)
    } 

    
    return (<>
    {commentClickStatus.clicking && <CommentCursor type={'add'}/>}
                <Menu trigger="click-hover" closeOnItemClick={false} {...(leftNav ? leftNavMenuProps : {})}>
                    <Menu.Target>
            <ActionIcon variant="transparent" 
                size={leftNav ? 28 : undefined}
                radius={leftNav ? 12 : undefined}
                onPointerOver={() => setHover1(true)}
                onPointerLeave={() => setHover1(false)}
                color={!hover1 ? iconColour.normal : iconColour.hover}
                style={
                  leftNav
                    ? {
                        backgroundColor: hover1 ? (iconColour?.hoverBg || "#f3f4f6") : "transparent",
                        border: hover1 ? `1px solid ${iconColour?.border || "#e5e7eb"}` : "1px solid transparent",
                      }
                    : undefined
                }>
                {leftNav ? (
                  <IconMessageCircle size={18} />
                ) : (
                  <Text size="lg">💬</Text>
                )}
                </ActionIcon>
                </Menu.Target>

        <Menu.Dropdown>
            <Menu.Item onClick={handleClick}>
                Add comment
            </Menu.Item>
            <Menu.Item>
                <Switch checked={showingComments} label="Show comments" color="gray" 
                onChange={() => setShowingComments(!showingComments)}/>
                </Menu.Item>
        </Menu.Dropdown>
                </Menu>
        
        </>
    );
};




export const MoveCommentButton = ({threadsId, artboard, position, iconTheme}) => {
    const {
        handleCommentButtonClick
    } = useObjectStore();

    const [hover1, setHover1] = useState(false)
    const handleClick = () => {
        handleCommentButtonClick('move', threadsId, artboard, position)
        // handleCommentButtonClick(!commentClickStatus.clicking)
    } 

    // to update single thread position we need to 
    // 1. get all id, position, artboard, projectKey for thread – replace position with new position
    // 2. send to realtime channel via realtime message
    // 3. in xano updateFunction trigger threadUpdate and change position
    // 4. message hits whole of channel (including client)
    // 5. all channel members loadThreads to show new position
    // 5b. how will this impact those with 'open' threads?

    // to update bulk threads off the back of an artboard change
    // 1. in xano artboard add/delete func, look for an update artboard of relevant threads
    // 1b. delete any threads in project, also delete comments that are ON that specific artboard
    // 1c. then minus one from artboard number of any threads in project with artboards larger than deleted artboard
    // 2. this means that if we have an artboard added or deleted, we need to trigger 'loadThreads' in channel members
    // 2b. might be able to only trigger this is we have needed to make thread updates, maybe make this conditional


    return (<>
    {/* {commentClickStatus.clicking && <CommentCursor clickFunction={handleClick} type={'move'} threadsId={threadsId} artboard={artboard} position={position} />} */}
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <ActionIcon
              variant="transparent"
              aria-label="Move comment"
              onPointerOver={() => setHover1(true)}
              onPointerLeave={() => setHover1(false)}
              onClick={handleClick}
              styles={{
                root: {
                  width: 32,
                  height: 32,
                  minWidth: 32,
                  minHeight: 32,
                  borderRadius: 4,
                  border: `1px solid ${hover1 ? (iconTheme?.iconHoverBorder || "#d1d5db") : (iconTheme?.iconBorder || editorModalBorder)}`,
                  backgroundColor: hover1 ? (iconTheme?.iconHoverBg || "#f9fafb") : (iconTheme?.iconBg || "#ffffff"),
                  color: hover1 ? (iconTheme?.iconHover || "#374151") : (iconTheme?.icon || "#6b7280"),
                  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
                },
              }}
            >
              <IconHandMove size={18} />
            </ActionIcon>
        </div></>
    );
};




